/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S7_R2_BodyInputs */

const tr_iletisim_s7_r2_body = /** @type {(inputs: Iletisim_S7_R2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parasal sınırların üzerindeki uyuşmazlıklar için Antalya Tüketici Mahkemeleri yetkilidir.`)
};

const en_iletisim_s7_r2_body = /** @type {(inputs: Iletisim_S7_R2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For disputes above the monetary limits, the Tüketici Mahkemeleri in Antalya have jurisdiction.`)
};

const de_iletisim_s7_r2_body = /** @type {(inputs: Iletisim_S7_R2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Streitigkeiten oberhalb der Wertgrenzen sind die Tüketici Mahkemeleri in Antalya zuständig.`)
};

const ru_iletisim_s7_r2_body = /** @type {(inputs: Iletisim_S7_R2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По спорам, превышающим денежные лимиты, компетентны Tüketici Mahkemeleri в Анталье.`)
};

/**
* | output |
* | --- |
* | "For disputes above the monetary limits, the Tüketici Mahkemeleri in Antalya have jurisdiction." |
*
* @param {Iletisim_S7_R2_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s7_r2_body = /** @type {((inputs?: Iletisim_S7_R2_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S7_R2_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s7_r2_body(inputs)
	if (locale === "de") return de_iletisim_s7_r2_body(inputs)
	if (locale === "ru") return ru_iletisim_s7_r2_body(inputs)
	return tr_iletisim_s7_r2_body(inputs)
});